import {forkJoin} from 'rxjs';
import {map} from 'rxjs/operators';

import {
    ApiError,
    ApiResponse,
    HttpStatusCodesEnum,
    PermissionApplicationsEnum,
    PermissionInterface,
    PermissionsService,
    ServerResponse,
    ServerResponseData
} from '@spa/api';

export class PortalPermissionsTrait {
    private constructor() {
    }

    /**
     * Account access permissions are spread across two applications - the Pro Web portal and the
     * Fund Portal (e.g. 'fund-portal:accounts:manage-accounts'). Both applications have to be
     * requested and merged into a single response, otherwise the Fund Portal permissions are
     * missing from the account rights forms.
     */
    static getAllPortalPermissionsRequest(
        permissionsService: PermissionsService
    ): ServerResponse<PermissionInterface[]> {
        return forkJoin([
            permissionsService.getAll(PermissionApplicationsEnum.ProWeb),
            permissionsService.getAll(PermissionApplicationsEnum.FundPortal)
        ]).pipe(
            map((responses: ServerResponseData<PermissionInterface[]>[]) => {
                const failedResponses = responses.filter((response: ServerResponseData<PermissionInterface[]>) => {
                    return response.status !== HttpStatusCodesEnum.Ok;
                });

                if (failedResponses.length > 0) {
                    return failedResponses[0];
                }

                const permissions = responses.reduce((
                    mergedPermissions: PermissionInterface[],
                    response: ServerResponseData<PermissionInterface[]>
                ) => {
                    if (Array.isArray(response.data)) {
                        mergedPermissions.push(...(response.data as PermissionInterface[]));
                    }

                    return mergedPermissions;
                }, []).sort((previous: PermissionInterface, next: PermissionInterface) => previous.id - next.id);

                return new ApiResponse<ApiError[] | PermissionInterface[]>(HttpStatusCodesEnum.Ok, permissions);
            })
        );
    }
}
